import { useState } from "react";
import { Box, Button, Container, Grid, Stack, Typography } from "@mui/material";
import { animated, useSprings, config } from "@react-spring/web";
import { Waypoint } from "react-waypoint";
import clientsIllustration from "../../images/clients.webp";
import experience from "../../images/experience.webp";
import experts from "../../images/experts.webp";
import marketing from "../../images/marketing.webp";
import media from "../../images/media.webp";
import office from "../../images/logo.jpg";

const FlexTypography = (props) => (
  <Typography variant="h1" sx={{ display: "flex" }} {...props} />
);

const RowStack = (props) => <Stack alignItems="center" {...props} />;

export default function About() {
  const [inview, setInview] = useState(false);
  const springs = useSprings(
    5,
    [500, 4, 30, 150, 50].map((i) => ({
      from: { clients: 0 },
      clients: inview ? i : 0,
      config: config.molasses,
      delay: 50
    }))
  );

  return (
    <Box
      sx={{
        width: "100%",
        pt: 4,
        pb: 2,
        overflow: "hidden"
      }}
      id="about"
    >
      <Container maxWidth="lg">
        <Box sx={{ margin: "auto", width: "100%", textAlign: "center" }}>
          <Typography variant="h3">Who We Are</Typography>
          <Typography variant="body1">
            KeywordsFly is a results-driven Growth Marketing Company in India
            <br />
            that offers solutions to Landing page, sale funnel building,
            generate qualified sales, & leads
            <br /> with guaranteed brand building. We are expertise in numbers
          </Typography>
          <Waypoint onEnter={() => setInview(true)}>
            <Grid container>
              <Grid item xs={6} md>
                <RowStack>
                  <img width={120} src={clientsIllustration} alt="clients" />
                  <FlexTypography>
                    <animated.div>
                      {springs[0].clients.to((n) => n.toFixed())}
                    </animated.div>
                    +
                  </FlexTypography>
                  Clients
                </RowStack>
              </Grid>
              <Grid item xs={6} md>
                <RowStack>
                  <img width={120} src={experience} alt="experience" />
                  <FlexTypography>
                    <animated.div>
                      {springs[1].clients.to((n) => n.toFixed())}
                    </animated.div>
                    +
                  </FlexTypography>
                  Years of Experience
                </RowStack>
              </Grid>
              <Grid item xs={6} md>
                <RowStack>
                  <img width={120} src={marketing} alt="marketing" />
                  <FlexTypography>
                    <animated.div>
                      {springs[2].clients.to((n) => n.toFixed())}
                    </animated.div>
                    +
                  </FlexTypography>
                  Guaranteed services
                </RowStack>
              </Grid>
              <Grid item xs={6} md>
                <RowStack>
                  <img width={120} src={media} alt="media" />
                  <FlexTypography>
                    <animated.div>
                      {springs[3].clients.to((n) => n.toFixed())}
                    </animated.div>
                    +
                  </FlexTypography>
                  Business Media
                </RowStack>
              </Grid>
              <Grid item xs={6} md>
                <RowStack>
                  <img width={120} src={experts} alt="experts" />
                  <FlexTypography>
                    <animated.div>
                      {springs[4].clients.to((n) => n.toFixed())}
                    </animated.div>
                    +
                  </FlexTypography>
                  Team Experts
                </RowStack>
              </Grid>
            </Grid>
          </Waypoint>
          <br />
          <Button
            sx={{ color: "white", mt: 2, mx: "auto", mb: { xs: 3, md: 0 } }}
            variant="contained"
            color="primary"
            size="large"
          >
            Register Here
          </Button>
        </Box>
      </Container>
    </Box>
  );
}
